// Home.js
import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, EffectFade } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/effect-fade';
import bvt1 from '../assets/home1.png';
import bvt2 from '../assets/home2.png';
import bvt3 from '../assets/home3.png';

const Home = () => {
  return (
    <div className="w-full bg-white">
      {/* Hero */}
      <section className="relative w-full h-[80vh]">
        <Swiper
          modules={[Autoplay, EffectFade]}
          effect="fade"
          loop
          speed={4000}
          autoplay={{ delay: 4000, disableOnInteraction: false }}
          className="w-full h-full"
        >
          {[bvt1, bvt2, bvt3].map((img, idx) => (
            <SwiperSlide key={idx}>
              <img
                src={img}
                alt={`Slide ${idx + 1}`}
                className="w-full h-full object-cover z-0"
              />
            </SwiperSlide>
          ))}
        </Swiper>

        {/* Capa oscura */}
        <div className="absolute inset-0 bg-black/60 backdrop-blur-sm z-10"></div>

        <div className="absolute inset-0 flex flex-col items-center justify-center text-white text-center px-4 z-20">
          <p className="text-base md:text-lg mb-4 tracking-widest uppercase text-white/90">
            Compromiso · Confianza · Resultados
          </p>
          <h1 className="text-4xl md:text-6xl font-bold mb-4 drop-shadow-lg">Inversiones BVT C.A.</h1>
          <p className="text-lg md:text-xl max-w-2xl drop-shadow">
            Soluciones integrales para el desarrollo de infraestructura, energía y servicios especializados.
          </p>
        </div>
      </section>

      {/* Sobre Nosotros */}
      <section className="py-12 px-6 bg-[#f9f9f9] text-center">
        <h2 className="text-3xl font-bold mb-4 text-[#003366]">¿Quiénes Somos?</h2>
        <p className="max-w-3xl mx-auto text-gray-700 text-lg leading-relaxed">
          Inversiones BVT, C.A, es una empresa con más de 14 años de experiencia, en el área de suministros, procura, dotación, consultorías, construcción de obras civiles, construcción de edificaciones metálicas y en concreto armado, servicio y mantenimiento de sistemas eléctricos de media y baja tensión, iluminación, asfaltado, alquiler de plantas de tratamientos de aguas y traslado de desechos petroleros, fabricación de unidades móviles (Tráiler). El resultado de nuestro esfuerzo se ha traducido en mejoras en la productividad de nuestros clientes. 
        </p>
      </section>

      {/* Pilares */}
      <section className="py-0 px-6 text-center">
        <h3 className="text-2xl font-bold mb-10 text-[#003366]">Nuestros Pilares</h3>
        <div className="max-w-6xl mx-auto grid md:grid-cols-3 gap-8 text-left text-gray-700 text-sm leading-6">
          <div>
            <h4 className="text-lg font-semibold mb-2">Profesionalismo</h4>
            <p>Contamos con un equipo técnico calificado en múltiples disciplinas del sector industrial.</p>
          </div>
          <div>
            <h4 className="text-lg font-semibold mb-2">Compromiso</h4>
            <p>Ejecutamos cada proyecto con responsabilidad, planificación y orientación a resultados.</p>
          </div>
          <div>
            <h4 className="text-lg font-semibold mb-2">Confianza</h4>
            <p>Relaciones de largo plazo con clientes públicos y privados de todo el país.</p>
          </div>
          <div>
            <h4 className="text-lg font-semibold mb-2">Solidez</h4>
            <p>Infraestructura propia y capacidad operativa para afrontar retos de gran escala.</p>
          </div>
          <div>
            <h4 className="text-lg font-semibold mb-2">Innovación</h4>
            <p>Incorporamos mejoras técnicas y soluciones adaptadas al entorno cambiante.</p>
          </div>
          <div>
            <h4 className="text-lg font-semibold mb-2">Alianzas</h4>
            <p>Vínculos estratégicos con instituciones, gobiernos regionales y proveedores líderes.</p>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Home;
